import { z } from 'zod';

/////////////////////////////////////////
// PERMITS CONTACTS SCHEMA
/////////////////////////////////////////

export const PermitsContactsSchema = z.object({
  id: z.bigint(),
  permit_id: z.number().int().nullable(),
  permits_extension_def_id: z.string().nullable(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  phone: z.string().nullable(),
  email: z.string().nullable(),
  address: z.string().nullable(),
  address2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  zip: z.string().nullable(),
  physical_address: z.string().nullable(),
  physical_address2: z.string().nullable(),
  physical_city: z.string().nullable(),
  physical_state: z.string().nullable(),
  physical_zip: z.string().nullable(),
  same_mail_and_physical_address: z.boolean().nullable(),
  user_id: z.number().int().nullable(),
  contact_type: z.string().nullable(),
  has_access: z.boolean().nullable(),
  license_number: z.string().nullable(),
  company_name: z.string().nullable(),
  is_applicant: z.boolean().nullable(),
  invited_at: z.coerce.date().nullable(),
  is_submitter: z.boolean().nullable(),
  is_active: z.boolean().nullable(),
  ignored_discrepancies: z.string().nullable(),
  verified_at: z.coerce.date().nullable(),
  verification_sent_at: z.coerce.date().nullable(),
  verification_token: z.string().nullable(),
  rowTimestamp: z.coerce.date(),
  countryId: z.string(),
  homeCountryId: z.string(),
})

export type PermitsContacts = z.infer<typeof PermitsContactsSchema>

export default PermitsContactsSchema;
